module.exports = __webpack_public_path__ + "img/index_pic30.8e6836cd.png";